export default {
  common: {
    onlineComParty: 'Party List',
    onlineGalleryParty: 'Online Gallery view Party',
    onlineConferenceParty: 'Online Conference Party',
    onlineKioskParty: 'Online Kiosk Party',
    operationFailed: 'Failed to start video or audio. Please check your capture device',
    closeOperationFailed: 'Operation failed, plesase try agin.',
    repeatVoipJoined: 'The device {deviceId}({nickName}) can not be add repeatedly.',
    chromeSuggest: '“Chrome” is recommended to visit TVU Partyline for a better experience.',
    gotIt: 'Got it',
    hostOperationMicroFailed: 'Fail to open mic. The device is not available.',
    hostOperationCameraFailed: 'Fail to open camera. The device is not available.',
    operationMicroFailed: 'The mic of the participant is unavailable.',
    operationCameraFailed: 'The camera of the participant is unavailable.',
    noData: 'No source is currently available',
    shareFailed: 'Sharing Failure',
    shareFailHead: 'Please, follow the instructions to enable the screen share:',
    shareFailText1: '1. Open System Preferences → Security & Privacy → Privacy Tab → Screen Recording.',
    shareFailText2: '2. If the applications checkboxes are locked for editing you will need to unlock those options by clicking the lock icon on the bottom left. Click the lock labeled “Click the lock to make changes”. When prompted, enter an admin username and password.',
    shareFailText3: '3. If it’s already checked, uncheck the checkbox for Google Chrome in the list on the right side. If prompted, choose “Later”.',
    shareFailText4: '4. Check the same checkbox for Google Chrome that you just unchecked. If prompted, choose “Quit & Reopen”.',
    invitedExpire: 'Invitation has expired',
    stopPrivateByTalkback: 'Talk back has enable, the curren private chat has been hung up.',
    mixMinusOn: 'PGM(mix minus): remove the source audio from Partyline.',
    mixMinusOff: 'PGM: maintain the source audio from Partyline.',
    mixMinus: 'Mix minus',
    noProgram: 'No running program',
    noMainWinDowData: 'No data',
    noReceiver: 'No available receivers',
    audience: 'Audience',
    audienceTips1: '· Audiences can only receive all video and audio from the party.',
    audienceTips2: '· Audiences can not provide their own video and audio.',
    audienceTips3: '· Audiences can connect with Host by “raise hand” and “private chat” fatures.',
    sendMediaRequest: 'Your request has been sent.',
    operatPermission: 'Operation permission',
    mediaPopupText: ' wants to modify your mic/camera device.',
    requestAgree: 'Your request to set up the mic/camera device has been admitted.',
    requestDeny: 'Your request to set up the mic/camera device has been denied.',
    setMicCameraSuccess: 'Mic/camera device setup successfully.',
    denySuccess: 'Deny successfully.',
    setMicCameraFailed: 'The current mic/camera device is unavailable.',
    theHost: 'The host',
    selectAccount: 'Select account:',
    versionText: 'Provide online receivers with version 7.4+.',
    tagText: 'After setting,the tagged participants in each party will go on its party-Main Window.',
    horizontalRow: 'Enable/Disable Horizontal row',
    verticalRow: 'Enable/Disable Vertical column',
    cellRow: 'Enable/Disable the cell audio',
    encoderOperationFailed: 'Operation failed',
    moreIndex: 'Failed, it exceeds the maximum({ maxNumber }) number of VFB uses.',
    useReceiver: 'The useage of Receiver VFB:',
    title: 'Party Name',
    code: 'Party ID',
    mode: 'Party Mode',
    email: 'Host',
    participantNumber: 'Participant number',
    operation: 'Operation',
    stopSuccess: 'Stop successfully',
    outputFailed: 'Output failed. Please use the receiver with version 7641+',
    tvuoneRemove: 'TVU One can be only moved to Common party.',
    no: 'No.',
    mic: 'Mic',
    allFullScreen: 'Main Window for all participants into full screen',
    allOutFullScreen: 'Main Window for all participants out of full screen',
    addParty: 'Add Party to Global COntrol',
    failedInGlobal: 'Operation failed, you are in Global Control module',
    notAllowDelete: 'You can not delete is using Global Control',
    noGlobalText: 'Click "Start a Global Control" to launch your first creation.',
    applyAll: 'Apply all',
    nameIsRequired: 'Name is required',
    applyAllTips: 'Make all parties use Global-MainWindow.',
    remark: 'Remark',
    validMute: 'Valid for parties only',
    validMove: 'Move participants to another party',
    refreshData: 'Refresh List',
    noGlobalData: 'No data',
    noSelectParticipant: 'Please first select which participants you want to move.',
    repeatJoin: 'Repeat Join',
    repeatContent: 'The current account has been logged in elsewhere. If you want to retain control of the meeting, please press F5 to refresh the page.',
    qrCodeText: 'Scan the QRcode on TVU Anywhere app',
    qrCodeText1: 'Scan the QRcode on Partyline app',
    slotSelection: 'Slot Selection',
    typeSelection: 'Type Selection',
    videoInput: 'Video Input',
    audioInput: 'Audio Input',
    setDevicePermission: 'Media Device Permission Failure',
    deviceContent: 'Chrome failed in loading the Media Device Permission pop up. Please, click "Continue" to provide permissions..',
    continue: 'continue',
    autoSwitchNewCameraSuccess: 'Auto switch new camera successfully',
    autoSwitchNewCameraFailed: 'Auto switch new camera failed',
    autoSwitchNewMicSuccess: 'Auto switch new mic successfully',
    autoSwitchNewMicFailed: 'Auto switch new mic failed',
    switchSpeakerSuccess: 'Auto switch speaker successfully',
    switchSpeaerFailed: 'Auto switch speaker failed',
    supportR: 'Support for >=7838',
    usageService: 'Usage Service',
    participateSetting: 'Participate Setting',
    nickName: 'Nickname',
    partyMode: 'Party Mode',
    layout: 'Layout',
    startNow: 'Start now',
    userGuide: 'User guide',
    tvuPartyLine: 'TVU Partyline',
    partyList: 'Party List',
    blockAccount: 'This account has been blocked',
    maxNumber: 'The number of pips including all participants, Main Window, Shared Screen, etc have reached the limit of',
    openAEC: 'Open AEC',
    openANS: 'Open ANS',
    openAGC: 'Open AGC',
    refreshAffect: 'Note: Takes affect after refresh the page.',
    dark: 'Dark',
    light: 'Light',
    theme: 'Theme',
    installAnyWhereText: 'Open/Install TVU Anywhere app',
    callupAnywhere: 'Call up TVU Anywhere app',
    partylineManage: 'Partyline - Workbench',
    partylineJoin: 'Partyline - Join',
    partylinePreviewInit: 'Partyline - Preview',
    partylinePreview: 'Preview|Partyline - {name}',
    partyTitle: 'Partyline - {name}',
    joinDeletParty: 'The current party has been deleted.',
    initCameraTips: 'The current {name} is not available, please switch another avaible device',
    switchFailed: 'Switch to the current camera failed.',
    initVideoTrack: 'Camera is connecting, please wait.',
    stopPrivateFirst: 'Operation failed, please stop all private converssation first.',
    checkAudioMsg: 'Are you talking? Your mic is off. Click the mic to turn it on.',
    youMute: "You're mute",
    rInOtherParty: 'The current receiver is in the {partyCode}',
    noAvailableDevice: 'No {deviceType} available',
    switchReceiverSource: 'Switch Receiver Source',
    receiverTips: 'When the TVUOne or Receiver joins the party, it will provide the following selections of "Video Input" and "Audio Input". Meanwhile, it will receive all participants audio',
    receiverPopText: 'The new added will replace the previous pip that has the same video input. Please confirm whether to continue?',
    generateSummary: 'Generate Summary',
    summary: 'Summary',
    inputLanguage: 'Input Language:',
    leave: 'leave',
    details: 'Details',
    lastFrame: 'Last Frame',
    empty: 'Empty',
    copySlot: 'Copy Slot {index}',
    notAllowed: 'Please set up this feature in the party setting after the party is enabled.',
    sendSetting: 'Send Setting',
    noVailiableInput: 'Unavailable, as no input is being detected.',
    audioSetting: 'Audio Setting',
    audioAdvancedSettings: 'Audio Advanced Settings',
    refreshSave: 'Refresh to save',
    mono: 'Mono',
    stereo: 'Stereo',
    audioFormat: 'Audio Output Format',
    audioQuality: 'Audio Quality',
    noisTips: 'Noise Reduction and Audio Enhancement',
    audioOutput: 'The audio output format is related to the audio capture.',
    selectTips: 'If the capture is mono, it is recommended to select Mono.',
    stereoNoOptions: 'AEC, ANS, AGC functions are not supported in “Stereo”',
    aecTips: 'Acoustic Echo Canceller',
    ansTips: 'Active Noise Suppression',
    agcTips: 'Automatic Gain Control',
    stereoTips: 'Stereo Control',
    refreshToSave: 'Refresh to save',
    pushTalkFailed: 'Please do not operate frequently',
    pushTalkOnlyOne: 'Only one push-to-talk button can be operated at a time.',
    pushTalkBackFail: 'Please "Click and Hold" for talk.',
    micListChange: 'The microphone list has changed',
    switchMicSuccess: 'Switch micphone device successfully',
    switchMicFailed: 'Switch micphone device failed',
    lazyAudioOpen: 'Lazy Audio notification',
    liveAndLazyAudioText: 'Lazy Audio function is enabled. The Receiver will only receive first mono channel after starting live.',
    invalidPartyIdText: 'Invalid Party ID',
    notSupportSwitchSpeaker: 'The current browser does not support switching speaker.',
    showUploadImage: 'Display upload image',
    waitingResult: 'Switch failed, please wait for the previous interface to return the result.',
    voipNotOperateCamera: 'VoIP does not support control the camera.'
  },
  debugPage: {
    title: 'PL Debug',
    partyCode: 'Party Code',
    join: 'Join',
    joined: 'Connection established successfully',
    notes: 'Note: This page is only available to TVU users',
    leave: 'leave',
    leaveSuccess: 'Leave successfully',
    deprecatedTitle: 'Important Notice',
    deprecatedMessage: 'This page will be deprecated and will redirect to Partyline Admin. Please ensure you have Partyline Admin primission.',
    redirectIn: 'Redirecting in {seconds} seconds',
    jumpNow: 'Go Now'
  },
  start: {
    getStarted: 'Get Started',
    startParty: 'Create Party',
    joinParty: 'Join Party',
    join: 'Join',
    cancel: 'Cancel',
    placeholder: 'Enter Party ID ',
    partyId: 'Party ID',
    startHead: 'Cloud Collaboration Solution For Video Conferences & Events',
    startText: 'TVU Partyline is a broadcast quality cloud collaboration solution providing live interaction in real-time in Partyline, Gallery view, Conference, and Kiosk mode.',
    learnMore: 'Learn more',
    learnMoreNext: ' about TVU Partyline',
    joinPlaceholder: 'Party ID or party shared info'
  },
  endParty: {
    end: 'End the party',
    title: 'End the party',
    content1: 'Do you really want to end the Party? ',
    content2: 'After end, all live feeds will be terminated and chat will be cleared.',
    cancel: 'Cancel',
    save: 'End'
  },
  chatM: {
    chat: 'Chat',
    publicRoom: 'Public Chat room',
    groupChat: 'Group chat',
    personalRoom: 'Personal Chat room',
    newMessage: 'New message',
    sendEveryone: 'Send messages to everyone',
    message: 'Message',
    searchPart: 'To: search the name of a participant',
    chatSet: 'Chat setting',
    chatNote: 'Note: "End party" will clear chat history.',
    lockPri: 'Lock private chat',
    lockPub: 'Lock public chat',
    sendM: 'Send message',
    toopPri: 'Once lock private chat, participants can only receive and send to Host.',
    tooPub: 'Once lock public chat, participants can only receive messages, but not send',
    moreChat: 'Partyline only supports written chat for one tab at a time'
  },
  Movepips: {
    movepip: 'Move pips',
    cancelOperations: 'Cancel batch operation',
    selectAll: 'Select All',
    cancel: 'Cancel',
    done: 'Done',
    selected: 'Selected',
    moveTo: 'Move to',
    cancelMove: 'Cancel',
    save: 'Save',
    moveTips: {
      title: 'Movement Operation',
      cancel: 'Cancel',
      save: 'Move'
    }
  },
  copy: {
    onCopy: 'Copy successfully',
    onError: 'Copy failed',
    rename: 'Rename successfully'
  },
  invite: {
    receivedCohost: 'Received Invites',
    invite: 'Invite',
    getLink: 'Get link',
    shareTo: 'Share with participants',
    copyLink: 'Copy link',
    saveInvite: 'Save',
    anyoneJoin: 'Anyone with the link can join',
    onlyUserJoin: 'Only users added to the list can join',
    onlyByPasscode: 'Anyone with passcode can join',
    emailNotation: 'Email Notification',
    emailCorrectly: 'Please input correct email',
    remove: 'Remove',
    clearUp: 'Clear',
    inviteCohoster: 'Add Co-host email',
    invitePlaceholder: "Add participant's email",
    inviteSetSuccess: 'Set successful',
    inviteSetCopySuccess: 'Set and Copy successful',
    inviteDeleteSuccess: 'Delete successfully',
    passCode: 'Passcode',
    copyPassCode: 'Copy passcode',
    passWordText: '6-digit password required.',
    plsInpPasscode: 'Please input passcode',
    setPasscodeSuccess: 'Set passcode successfully',
    wrongPasscodeFormat: 'Please enter the correct password format.',
    alreadyInvited: ' already invited',
    inviteEndParty: 'End Party',
    unBind: 'Unbind: No administrator assgined.',
    accountAssociation: 'Account Association',
    accountAssociationText: 'Assign an administrative account to each Receiver and share party link, then the account can access the corresponding Station UI.',
    canNotBandHostEmail: 'You can not bind the account to the host.'
  },
  personalInfo: {
    receivedCohostTextSecond: 'except for the "delete party" and the "add co-host".',
    receivedCohostTextOne: 'The one will have equal management rights with the party owner',
    partyName: 'Party name',
    receivedCohost: 'Co-Host',
    lang: 'Language',
    logOut: 'Sign out',
    login: 'Login',
    register: 'Register',
    collaborate: 'Collaborate',
    inviteCollaborators: 'Invite collaborators',
    receivedInvites: 'Received Invites',
    applicant: 'Applicant',
    inviteationTime: 'Invitation Time',
    addEmailTile: 'After adding emails',
    liveWithAccount: '- You can start live with the added account.',
    moveAccount: '- You can move the pip into the added account.',
    pullAccount: '- You can pull PP PGM from added account to your Main Window.',
    popupTitle: 'Collaborate with other hosts',
    noInvitedEmail: 'Please input which you want invite email.',
    inviting: 'Pending',
    declined: 'Declined',
    Permission: 'Permission',
    accept: 'Accept',
    decline: 'Decline',
    acceptedRequest: 'Accepted request',
    acceptedCoHostRequestText: 'You will have equal rights to manage the party as the party owner.',
    declineCoHostRequestText: 'You have declined the request. You can modify the button in the email to accept the request.',
    RequestCoHostExpiredText: 'The invitation has expired, if you want to be invited, please contact the host.',
    acceptedRequestText: 'The applicant will be able to live with your Producer and move his participants to your Partyline.',
    declineRequestText: 'You have declined the request and the applicant will not be able to share his sources to you.',
    declineRequest: 'Decline request',
    RequestExpired: 'Request has expried',
    removeInvitedMe: ' has canceled his invitation to you.',
    hostRemoveInvited: ' has canceled invitation you.',
    RequestExpiredText: 'The invitation has expired, if you want to be invited, please contact the host.',
    acceptSuccess: 'Accepted successfully, the applicant will be able to share with you his video sources.',
    acceptCancel: 'Declined successfully, the applicant won’t be able to share with you his video sources.',
    acceptHostSuccess: 'Accepted successfully, you will have equal rights to manage the party as the party owner.',
    acceptHostCancel: 'Declined successfully.',
    accepted: ' has accept your invite',
    hostSaveSuccess: 'The mail requests have been sent to the specified users.',
    forbidSetting: 'Forbid setting email is yourself.',
    refuseInvite: ' has declined your invitation.',
    hadInvited: 'The current email had invited.',
    hadCoHostInvited: 'The person is already a co-host.',
    pending: 'Waiting for acceptance',
    account: 'Account',
    collaboratePopupTitle: 'TVU Partyline intends to share with you his video sources to your Producer and Partyline services.',
    collaboratePopupLike: ' would like to add you as a collaborator.',
    cohostPopupLike: 'would like to add you as a co-host for',
    cohostPopupParty: 'party.',
    collaboratePopupAllow: 'By allowing that:',
    collaboratePopupDetail1: '· The applicant can live their participants with your Producer programs.',
    collaboratePopupDetail2: '· The applicant can move their participants to your Partyline.',
    collaboratePopupDetail3: '· The applicant can pull your Producer program as video return.',
    cohostPopupDetail1: '· The party will be in your party list.',
    cohostPopupDetail2: '· You will have equal management rights with the party owner.',
    backToWorkBench: 'Back to Workbench'
  },
  commonPartyHost: {
    topContent: {
      partyName: 'Party Name',
      partyId: 'Party ID',
      copy: 'Copy',
      endParty: 'End Party',
      send: 'Send',
      partyOwner: 'Party Owner'
    },
    leftPane: {
      title: {
        party: 'Partyline',
        group: 'Gallery View',
        coordinator: 'Conference',
        kiosk: 'Kiosk',
        arena: 'Arena',
        globalControl: 'Global Control',
        station: 'Station',
        interview: 'Interview'
      },
      sorting: 'Sorting by',
      date: 'Date',
      name: 'Name',
      type0: 'Date',
      type1: 'Name',
      coHost: 'Co-Host',
      type2: 'Global Control',
      partyOperation: {
        rename: 'Rename',
        copyLink: 'Copy Link',
        lock: 'Lock participant name',
        unlock: 'Unlock participant name',
        invitation: 'Invitation rules',
        partySetting: 'Party setting',
        hide: 'Hide link sharing for participant',
        show: 'Show link sharing for participant',
        loginHide: 'Hide full screen/login for participant',
        loginShow: 'Show full screen/login for participant',
        delete: 'Delete',
        remove: 'Remove from Global Control',
        AddCoHost: 'Add Co-host',
        ReceiverCoHost: 'Received Invites',
        deleteCoHost: 'Quit as Co-host',
        addParty: 'Add Party'
      },
      party: 'Start a partyline',
      group: 'Start a gallery view',
      conference: 'Start a conference',
      kiosk: 'Start a  kiosk mode',
      globalControl: 'Start a Global Control'
    },
    turnOffInterview: 'Turn off Intercom',
    turnOnInterview: 'Turn on Intercom',
    turnOnIntercom: 'Turn on two-way Intercom (private chat)',
    turnOffIntercom: 'Turn off two-way Intercom (private chat)',
    turnOnMessage: "The initator and recipients won't be heard by the others outside the chat.",
    turnOffMessage: 'The private chat will be stopped from both side.',
    notAllowedStop: 'This Intercom can only be stopped by Host.',
    hostTurnOffOneWay: 'You can stop one-way chat with this pip',
    outsideText: 'The pepole outside the chat will hear you.',
    hostTurnOnOneWay: 'You can restart the one-way chat with this pip.',
    outsideText1: 'The pepole outside the chat will not hear you.',
    turnOnOneWayIntercom: 'Turn on one-way Intercom (private chat)',
    turnOffOneWayIntercom: 'Turn off one-way Intercom (private chat)',
    stopBoth: 'The chat will be stopped from both side.',
    allowPrivate: 'You are allowed to start Intercom conversations.',
    notAllowPrivate: 'Host has turned Intercom off and all intercom conversations are going to be stopped.',
    receiveTwoWayPrivate: '{nickName} started the two way intercon with you.',
    receiveOneWayPrivate: '{nickName} started the one way intercon with you.',
    cancelOneWayPrivate: '{nickName} ended the one way intercon with you.',
    cancelTwoWayPrivate: '{nickName} ended the two way intercon with you.',
    sendTwoWayPrivate: 'You start the two way intercon with {nickName}.',
    sendOneWayPrivate: 'You start the one way intercon with {nickName}.',
    endTwoWayPrivate: 'You end the two way intercon with {nickName}.',
    endOneWayPrivate: 'You end the one way intercon with {nickName}.',
    switchDeviceFailed: 'Please try switching device again later.',
    addPip: 'Please invite participants to join.',
    sendPrivate: 'The Intercom has been turned on, and this participant will talk to you.',
    endPrivate: 'The Intercom feature has been turned off.',
    turnOnIntercommunicate: 'Intercommunication has been connected, associated personnel can communicate with each other.',
    turnOffIntercommunicate: 'The Intercommunication has been disconnected.'
  },
  mainWindow: {
    noSource: 'No Source',
    noVideoReturn: 'No Video Return',
    establishContact: 'Establish contact with Producer:',
    sameAccount: '1. Producer and Partyline keep the same account.',
    synchronize: '2. Producer PGM will be synchronized in Partyline.',
    none: 'None',
    producerPgm: 'Producer PGM',
    receiverVF: 'Receiver Video Feedback',
    success: 'Success',
    mainW: 'Main Window',
    producer: 'Producer',
    sourceFromWindow: 'Source for main window from host',
    tagMainWindow: 'The tagged participants are on Main Window of their respective party.',
    unpin: 'Unpin',
    unpinTips: 'Click to Unpin from Main Window.',
    dobluClick: 'double-click video'
  },
  addTvuOne: {
    add: 'Add TVU Device',
    autoRecover: ' (auto recover)',
    addToP: 'Add to Partyline',
    receiverSettingTitle: 'Receiver Setting',
    producerSettingTitle: 'Producer Setting',
    channelSettingTitle: 'Channel Setting',
    placeholder: 'search name or ID',
    tvuone: 'TVU Device',
    theTvuOne: 'The TVUOne',
    inThe: 'is in the',
    chooseAll: 'Choose all',
    selected: 'selected',
    adds: 'Add',
    adding: 'Adding...',
    remove: 'Remove',
    next: 'Next',
    deviceVersion: 'The device with "{hwName}: {build}" is not supported. It requires version {supportedBuild}+',
    TestedDevices: 'Tested devices',
    mediaHub: 'MediaHub',
    receiver: 'Receiver',
    pack: 'TVUOne',
    producer: 'Producer',
    channel: 'Channel',
    all: 'All',
    online: 'Online',
    offline: 'Offline',
    recover: 'Auto Recover',
    voip: 'VoIp',
    noAudio: 'No Audio',
    tvuoneSettingTitle: 'TVUOne Setting',
    recoveryTips: 'Maintain TVU Devices in the party after shutdown (Require manual removal or End Party)',
    deviceOffline: 'The current device is offline',
    deviceInParty: 'The current device is in {partyCode}',
    removeTips: 'Remove from “Auto Recover” list, if the devices are still in the party then they remain in the party.',
    autoRecoverTips: 'Devices added in this way have an auto-recovery feature, which means that if the device is taken offline and brought back online without being manually removed, it will automatically return to the party.',
    packVoIPTip: 'TVUOne will join the party with its audio input being the 3.5mm connector. On the output, it will get all the participants audio.',
    receiverVoIPTip: 'R will join the party with its audio input being Pre Amp input. ',
    receiverVoIPTip1: 'On the pre amp output, it will get all the participants audio.',
    recevierVersion: 'R version 8.1',
    switchPackSource: 'Switch TVUOne source',
    switchContent: 'The current TVUOne is in the {partyCode}, do you want to switch it to the current party?',
    deviceHadJoin: 'The device has been added in "{partyList}" party',
    hasAlreadyJoin: 'Devices with identical configurations cannot be added repeatedly.',
    removing: 'Currently leaving...',
    confrimRestart: 'Do you want to restart the encoder',
    hasSelectedNumber: 'Selected {number} devices',
    joinMultiRFailed: 'Failed to add {rNameLiist}',
    confirmSwitch: 'Do you want to switch to the current party?',
    notSupportVoIP: 'The current device version is { version} not support VoIP',
    autoDuck: 'Auto Duck',
    duckLevel: 'Duck level:',
    autoDuckTitle: 'When the option is enabled, you can determine what channel will be auto ducked once audio presence is detected on the opposite channel.',
    notSupportControl: 'Does not support control Pack or Receiver media device.'
  },
  shareScreen: {
    share: 'Share Screen'
  },
  commonSetting: {
    participantSetting: 'Participant Setting',
    resolution: 'Resolution',
    high: 'High',
    low: 'Low',
    lazyAudio: 'Lazy Audio',
    on: 'on',
    off: 'off',
    cloudProxy: 'Cloud proxy',
    vfbSetting: 'VFB Setting',
    framerate: 'Frames rate(fps)',
    default: 'default',
    bitrate: 'Bitrate',
    lazyContent: 'Turn on, it will show Lazy Audio button in each pip.',
    onLazyAudioTip: 'Turn on "Lazy Audio" and no one can hear the source audio.',
    offLazyAudioTips: 'Lazy Audio off',
    onLocalLazyAUdioTip: 'Turn on "Lazy Audio"(Ctrl+L) and no one can hear the source audio.',
    offLocalLazyAUdioTip: '"Lazy Audio"(Ctrl+L) off',
    turnOnLazy: 'Turn on, channel 2 audio will be pushed, when pip live',
    ctrlL: 'Ctrl+L',
    hostLazyDisableTips: 'Click it, change from "L" audio channel to "R" to Receiver.',
    hostLazyOnTips: 'Click it, change from "R" audio channel to "L" to Receiver.',
    lazyAudioLTips: '· Start live, only "L" audio channel to Receiver.',
    lazyAudioRTips: '· Start live, only "R" audio channel to Receiver.',
    click: '· Click',
    lazyAudioLText: 'it and start live, only "R" audio channel to Receiver.',
    lazyAudioRText: 'it and start live, only "L" audio channel to Receiver.',
    cannotHear: "· Participant can't hear you.",
    lTips: '"L" audio channel ',
    lOutputToR: '"L" audio channel of Lazy Audio output to Receiver.',
    rOutputToR: '"R" audio channel of Lazy Audio output to Receiver and no one can hear the source audio.'
  },
  operationBtn: {
    AudioOnlyEnabled: 'Audio-Only Mode enabled',
    on: 'Turn on',
    off: 'Turn off',
    camera: ' Camera',
    microphone: ' Microphone',
    speaker: ' Speaker',
    selectMicrophone: 'Select a Microphone',
    selectSpeaker: 'Select a Speaker',
    selectCamera: 'Select a Camera',
    shareScreen: 'Share Screen',
    stopShareScreen: 'Stop Screen Share',
    chat: 'Chat',
    voice: 'Voice content',
    tagExplain: 'After a command from Global,the tagged participants will go on its party-Main Window.',
    notAllowed: 'Private chat is unavailable when Audio Matrix is on.',
    deviceBlock: '{deviceType} is blocked by the system.',
    voipTips: 'VoIP: the feature of two-way communication between this participant and this Receiver',
    notStopLive: 'The TVUOne leaves the party but doesn’t stop live.'
  },
  btnText: {
    rename: {
      text: 'Rename'
    },
    removeParticipant: {
      text: 'Remove from Party'
    },
    setCrew: {
      text: 'Production Crew'
    },
    cancelCrew: {
      text: 'Participant'
    },
    startPrivateConversation: {
      text: 'Set private chat'
    },
    cancelPrivateConversation: {
      text: 'Hang up private chat'
    },
    replace: {
      text: 'Replace'
    },
    roleSetting: {
      text: 'Role setting'
    },
    setSpeaker: {
      text: 'Speaker'
    },
    cancelSpeaker: {
      text: 'Participant'
    },
    cancelQuestionSpeaker: {
      text: 'Participant'
    },
    hangUpInterview: {
      text: 'Hang up interview'
    },
    setQuestionSpeaker: {
      text: 'Interviewer'
    },
    interviewer: {
      text: 'Interviewer'
    },
    setPublicTalk: {
      text: 'Set as Interviewer'
    },
    cancelQuestioner: {
      text: 'Participant'
    },
    cancelQuestionerRemove: {
      text: 'Remove from Interviewer Queue'
    },
    setQuestioner: {
      text: 'Participant'
    },
    addQuestioner: {
      text: 'Add to Interviewer Queue'
    },
    toTop: {
      text: 'To top'
    },
    participant: {
      text: 'Participant'
    },
    denyRaiseHand: {
      text: 'Remove from Raise hand queue'
    },
    setBroadcast: {
      text: 'Broadcaster'
    },
    setPublicSpeaker: {
      text: 'Public speaker'
    },
    editTagName: {
      text: 'Edit tag name'
    },
    fullScreen: {
      text: 'Full screen'
    },
    moveParty: {
      text: 'Move to'
    },
    SetTag: {
      text: 'Tag as Main Window'
    },
    CancelTag: {
      text: 'Cancel Tag'
    },
    audience: {
      text: 'Audience'
    },
    anyWhereSetting: {
      text: 'Setting'
    },
    setting: {
      text: 'Setting'
    },
    mainwindow: {
      text: 'Pin as Main Window'
    },
    unMainwindow: {
      text: 'Unpin as Main Window'
    },
    uploadImage: {
      text: 'Upload image'
    },
    fromComputer: {
      text: 'From Computer'
    },
    formImageGallery: {
      text: 'From Image Gallery'
    }
  },
  tagName: {
    editTagName: 'Tag name setting',
    tagInfo: 'Tag name is only visible to you.',
    tagName: 'Tag name',
    add: 'Add tag name',
    del: 'Delete',
    sub: 'Submit'
  },
  startNewParty: {
    partyNumber: 'Party number',
    contents: 'In common party, the maximum number of participants can be displayed',
    defaulltParticipants: '30 participants (default)',
    cancel: 'Cancel',
    apply: 'Apply',
    participantSetting: 'Participation Settings',
    participantSettingSucceTips: 'Participation Settings Successfully.',
    name: 'Name',
    corporation: 'Corporation',
    on: 'ON',
    off: 'OFF',
    submit: 'Submit',
    participantSettingSuccessful: 'Participation Settings have been modified successfully.',
    participantNameSuccessful: 'The participant name has been modified successfully.',
    createSuccessful: 'Create party successfully'
  },
  removeParty: {
    removeS: 'Removed successfully',
    removeF: 'Remove failed'
  },
  deleteParty: {
    delS: 'Delete successfully',
    delF: 'Delete failed'
  },
  pushParticipantSource: {
    destination: 'Select Video Return Source',
    // 特殊用于commonParty
    specialDestination: 'Select a destination',
    success: 'Start live successfully',
    failed: 'Failed to start live',
    stopLive: 'Stop live successfully',
    switchLive: 'Switch live',
    cancel: 'Cancel',
    confirm: 'Confirm',
    content1: 'The current Receiver is living with',
    content2: 'do you want to switch to the current source.',
    outputContent1: 'The current Receiver is outputing with',
    outputContent2: 'do you want to switch to the current party.'
  },
  authorizeOperation: {
    authorize: 'Authorize operation',
    success: 'Authorize successfully',
    removeS: 'Remove successfully',
    failed: 'Authorized failed',
    ok: 'OK',
    content: 'With ',
    content1: ' set to "Production Crew", them will be able to establish private conversations.',
    switchNewRole: 'Switch "Production Crew" role',
    switchConfirm: 'Are you sure to switch the Production Crew permissions to ',
    role: 'Role as'
  },
  audioChannels: {
    audioChannels: 'Audio Pair',
    rvt: 'VFB Setting',
    audioSetting: 'Producer Setting',
    liveSource: 'Live Source',
    stereo: 'Stereo',
    mutiple: 'Multiple',
    cancel: 'Cancel',
    send: 'Send',
    stop: 'Stop',
    gallery: 'Gallery',
    gotIt: 'Got it'
  },
  partylineGuest: {
    leave: 'Leave Party',
    isSharing: '  is sharing',
    limitation: 'The number of Co-host has reached the limitation of 3.',
    endPartyNotice: 'The host has ended the party.',
    removeFromParty: 'You have been removed from the party.',
    backHome: 'Back to Home',
    createPrivateConversation: 'Create private conversation successfully',
    privateConversationHung: 'The private conversation has been hung up.',
    switchPrivateCon: 'Switch Private Conversation',
    hungContent: 'After opening a new session, the current private conversation will be hung up. Do you confirm to continue?',
    save: 'Yes',
    cancel: 'No'
  },
  galleryHost: {
    output: 'Output',
    Default: 'Live Source',
    group: 'Live Source',
    send: 'Send',
    stop: 'Stop',
    preview: 'Preview',
    sharing: 'Sharing',
    shareScreen: 'Share Screen',
    sendSucc: 'Send successfully',
    sendFailed: 'Send failed',
    stopSucc: 'Stop successfully',
    outputPlaceholder: 'Select a destination',
    nameOperation: 'Name Operation',
    nameOperationCon: 'Show the names of participants',
    cancel: 'Cancel',
    ok: 'OK',
    operationS: 'Operation successfully',
    stopOperationS: 'Operation successfully',
    fillInRule: 'Fill-in rule',
    rulesDes: 'Rules for filling empty seats during video output.',
    autoFilled: 'Auto filled by waiting queue',
    donotRe: 'Do not replace but display the last frame',
    copySLot: 'Do not replace and repeat empty slots with selected position',
    chooseWho: 'Choose who you want to replace',
    setSuccess: 'Set successfully',
    fullScreen: 'Full screen',
    exitFullScreen: 'Exit full screen',
    changeSuccess: 'Changed successfully',
    privateChatQueue: 'Raise Hand Queue',
    selectOneToChat: 'Select one to setup a private channel',
    queueNoParti: 'No participant in the queue',
    privateChannel: 'Private channel',
    done: 'Done',
    talk: 'Talk',
    hangUp: 'Hang up',
    privateRequestRemove: 'The private chat request has been removed.',
    privateRequestSet: 'The private chat is set up.',
    netWorkPoor: 'The network is poor. Please refresh the page.',
    privateChatHungUp: 'The private chat has been hung up.',
    replaceParticipant: 'Replace Participant',
    seated: 'Seated',
    waiting: 'Waiting',
    noParticipant: 'No participant.',
    yesRe: 'Yes, replace',
    no: 'No',
    replace: 'Replace',
    replaceOne: 'Do you want to replace each other position?',
    replaceTwo: 'In the current seat, the selected pip will be swapped for the current pip. Continue?',
    replaceSuccessful: 'Replaced successfully',
    renameParty: 'Modify party name successfully',
    renamePartyFailed: 'Failed to modify party name',
    endedPartySuccess: 'Ended successfully',
    movePaticipant: 'are confirmed to be moved to',
    movePipTips: 'Are you sure to move the participant(s) to',
    movePartySuccess: 'Move participant successfully',
    moveSuccessExpectTagger: 'Everyone was moved successfully except the Tagger.',
    movePartyFailed: 'Operation failed',
    broadCaster: 'Broadcaster',
    broadcasterTips: 'The source everyone can see and hear.',
    StopBroadcast: 'Stop broadcast',
    publicSpeaker: 'Public Speaker',
    talkWithEach: 'Talk to each other',
    noReplace: 'Please select which you want to replace.',
    fontName: 'Font name',
    fontNamePlaceholder: 'Please select font name',
    imageGallery: 'Image Gallery',
    imageList: 'Image List'
  },
  galleryParticipant: {
    hideMe: 'Hide Me',
    showMe: 'Show Me',
    applyChat: 'Raise Hand',
    sendChatRequst: 'The private chat request has been sent.',
    removeChatRequest: 'The request has been removed.',
    privateConversaitonEnd: 'The private conversation is end.',
    publicSpeaker: 'You are the public speaker',
    nowSpeaker: 'is the public speaker',
    websiteSoundOff: 'Website sound off',
    websiteSoundOn: 'Website sound on',
    cameraTips: 'Operation permission',
    gotIt: 'Got it',
    deny: 'Deny',
    admit: 'Admit',
    cameraTipCon: 'The host wants to turn on your camera',
    mediaPopupText: ' wants to modify your mic/camera device.',
    fullParticipatnes: 'Thanks for participating. Our Queue is currently full, please try again later'
  },
  conferenceHost: {
    muteSite: 'Mute the site',
    mute: 'Mute',
    mainWindow: 'Main Window',
    Speaker: 'Speaker',
    selectSource: 'Select a source',
    None: 'None',
    producerPgm: 'Producer PGM',
    VideoFeedBack: 'VideoFeedBack',
    noSpeakerDesign: 'No Speaker designated',
    noSpeakerMessage: 'Please, wait until Host starts Video Return',
    designSpeaker: 'Designate the speaker from the speaker drop-down box',
    noQuestionerDesign: 'No Interviewer designated',
    designQuestioner: 'Designate the interviewer from the interviewer queue',
    questionerQueue: 'Interviewer queue',
    selectSpeaker: 'Select a speaker',
    selectVfb: 'Select a VFB',
    setSpeakerSuccess: 'Set speaker successfully',
    setPgmSuccess: 'Success',
    setPgmFailed: 'Failed',
    setQuestionerSuccess: 'Set successfully',
    setQuestionerFailed: 'Set failed',
    setQuestionQueue: 'Set successfully',
    removeQuestionQueue: 'Set successfully',
    raisedHandQueue: 'Raised hand queue',
    num: 'Num',
    handQueuePar: 'Participant',
    handQueueParCoporation: 'Corporation',
    handQueueParOperation: 'Operation',
    receiverVf: 'receiverVF'
  },
  conferenceParticipant: {
    offCamera: 'Turn off camera',
    onCamera: 'Turn on camera',
    offMicrophone: 'Turn off microphone',
    onMicrophone: 'Turn on microphone',
    applyPubHost: 'Raise Hand',
    applyPubHostTips: 'Private chat request has been sent.',
    cancelApplyPubHostTips: 'The private chat request has been canceled.',
    publicTalk: 'Public Talk',
    leaveParty: 'Leave the party',
    areYouOk: 'Are you sure you want to leave the party?',
    cancel: 'Cancel',
    leave: 'Leave'
  },
  kioskHost: {
    Tag: 'Tag',
    VFB: 'VFB',
    PP: 'PP',
    PIP: 'Participant',
    pip: 'Participant',
    pipOne: 'Participant',
    pbpTwo: 'PBP (2x Participants)',
    broadCasterPip: 'Broadcaster (Participants)',
    speakerPip: 'Speaker (Participants)',
    PBP: 'PBP',
    Broadcaster: 'Broadcaster',
    Speaker: 'Speaker',
    shareScreen: 'Shared Screen',
    displayLocation: 'Display location',
    asPip: 'As a pip',
    asMainWinddow: 'As Main window',
    me: 'Me',
    exitFullScreen: 'Exit full screen',
    addBack: 'Add Background/Logo',
    done: 'Done',
    logo: 'Logo',
    background: 'Background',
    placingPositionSetting: 'Placing position setting',
    imageList: 'Image list',
    choosePositionOfPicture: 'Please choose the position of the picture',
    bottomSide: 'At the bottom',
    rightSide: 'On the right side',
    renameSuccessful: 'Renamed successfully',
    renameFailed: 'Failed to rename',
    requestHasBeenSend: 'The request has been sent and awaiting approval',
    requestDeny: 'Your request has been denied.',
    setBackGroundS: 'Set background image successfully',
    selectSource: 'Select source',
    selectLeftSource: 'Select the left source',
    selectRightSource: 'Select the right source',
    setLogoS: 'Set logo image successfully',
    selectImg: 'Select img',
    uploadLogo: 'Upload Logo',
    displayArea: 'Display area',
    imageFormat: 'Image format',
    maxSize: 'Max 10MB each',
    uploadBtnText: 'Click to upload',
    useDefaultLogo: 'Use default logo',
    sourceType: 'Source type',
    vfbSource: 'VFB (Receiver Video Return)',
    ppSource: 'PP (Producer)',
    shareSource: 'Shared Screen',
    confirmTodelete: 'Do you want to delete it?',
    cannotDelete: 'The current image cannot be deleted because it is in use.',
    deleteUploadImg: 'Delete logo image',
    deleteUploadImage: 'Are you sure to delete this image?',
    yes: 'Yes',
    operateImageFailed: 'Operation failed, the current image is using',
    operateImageFailedPip: 'Operation failed, the current logo has been set to participant',
    saveSuccess: 'Upload successfully',
    deleteSuccess: 'Delete successfully',
    deleteBackgroundImg: 'Delete background image',
    pbpErrorPopup: 'Please stop the current Main Window source first.',
    muteAllMic: 'Mute All Mic',
    muteMic: 'Mute Mic',
    unmuteAllMic: 'Unmute All Mic',
    unmute: 'Unmute Mic',
    unmuteMic: 'Unmute Mic',
    allFullScreen: 'All to Full Screen',
    allOutFullScreen: 'All out of Full Screen',
    toAllParty: 'Main Window to All parties:',
    globalControl: 'Global Control',
    editGroupFootText: 'Select party to add to Global Control.',
    hadSelected: ' Selected',
    addToGlobalControl: 'Add to Global Control',
    controlName: 'Global Control Name',
    partySelect: 'Selected: ',
    controlSelectPlac: 'Select an option or create one',
    notEnough: 'Please select meetings number more than two',
    fullScreenAuth: 'Full screen authorization',
    fullScreenAuthText: 'Do you agree to full screen operation',
    tagInput: 'Taggers will be on party-Main Window'
  },
  responeInfo: {
    tryAgain: '{errorCode}: Please try again later',
    maximumParty: 'Exceed the maximum party creation number ',
    wsConnected: 'WebSocket connected successfully.',
    wsDisconnected: 'Not connected, Connecting....'
  },
  commonFunction: {
    Owner: 'Owner',
    CoHost: 'Co-host',
    mirror: 'Remote Mirror: It will take effect on both local and receiving sides.',
    localMirror: 'Local Mirror: It will take effect on the local preview.',
    rotate: 'Rotate 90°',
    bottomDown: 'Hide the bottom menu bar',
    bottomUp: 'Show the bottom menu bar',
    MuteHostSound: 'Mute Host sound',
    corporationRequired: 'Corporation is required',
    nameRequired: 'Name is required',
    notOperateFrequery: 'Please do not operate frequently',
    operateSuccessful: 'Operate successfully',
    operateFailed: 'Operate failed',
    reconnecting: 'Reconnecting...',
    hideInviteButtonTips: 'The shared link is hidden. Participants will not be able to see the copy button',
    showInviteButtonTips: 'The shared link is shown. Participants will be able to see the copy button',
    hideFullScreenLoginButton: 'The login and full screen button is hidden. Participants will not be able to see those button',
    showFullScreenLoginButton: 'The login and full screen button us shown. Participants will be able to see those button',
    switchToParty: 'Switch to Party',
    changeLayout: 'Change Layout',
    switchMainWindow: 'Switch Main Window Source',
    mainWindowSource: 'Main Window is playing the source, do you really switch to the shared screen?',
    broadcasterSource: 'Main Window is playing the source, do you really switch to the broadcaster？',
    autoPlayFailed: 'The video auto play was interrupt by browsers, do you want to resume?',
    switch: 'Switch',
    cancel: 'Cancel',
    pictureInpicture: 'Picture in Picture',
    crewReason: 'Because the Production Crew is working.',
    host: 'host',
    participant: 'participate',
    broadCaster: 'You are the broadcaster',
    isBroadCaster: ' is the broadcaster',
    privateConversation: 'Host has set up a private conversation with you.',
    newPrivateConversation: '{nickName} is privating conversation with you.',
    cancelPrivateConversation: '{nickName} has ended the Intercom call.',
    enableIntercom: 'You are allowed to start intercom conversations',
    disableIntercom: 'Host has turned Intercom off and all intercom conversations are going to be stopeed.',
    someOneRemoveYou: 'Someone has removed you from the party.',
    hasCameraOff: 'Host has turned your Camera OFF',
    hasMicrophoneOff: 'Host has turned your Mic OFF',
    crewTips: 'Operation failed, you are crew permission and you can conversation with host directed.',
    crewMessage: 'Operation failed, you are has conversation.',
    privateMessage: 'Operation failed, you are in private chatting.',
    operateBroadcaster: 'Operation failed, you are the broadcaster.',
    operatePublicSpeaker: 'Operation failed, you are the public speaker.',
    addSource: 'Add Source',
    contactWithProducer: 'Establish contact with Producer',
    contactFirstOne: 'Producer and Partyline keep the same account.',
    contactSecondOne: 'Producer PGM will be synchronized in Partyline.',
    noReceiverTips: 'There is no any receiver/PGM, please create a program in Producer firstly.',
    participantTips: 'Participant has Lazy Audio enabled, please wait participant to disable it for starting private conversation.',
    pushTalkTips: 'Participant has push to talk enabled, please wait participant to disable it for starting private conversation.',
    currentSoure: 'The current source',
    isOffline: 'is offline',
    isNotCamera: 'is not have camera',
    isOn: 'is on ',
    party: ' party',
    addCommonParty: 'Add to Common Party',
    commonParty: 'Partyline',
    waitingLoading: 'Please wait while loading',
    soundOfSite: 'Sound of the site',
    noAccess: 'No access',
    audio: 'Audio',
    addDeviceFailed: 'The current device {deviceName} add failed({reason})'
  },
  remainWords: {
    liveBookTitle: 'Once participants join, it will automatically go live.',
    liveBook: 'Live booking',
    shareScreenTips: 'Please to stop broadcast, if you want to share screen.',
    stopClick: 'Please click "Stop sharing" button to stop sharing',
    anotherSharing: 'Another host is sharing',
    hostModifyParticipant: 'Host has modified your Participation Settings.',
    hostHasMicrophoneOn: 'Host has turned your Mic ON',
    operationTalking: 'Operation failed, you are in talking.',
    pushToAudioMixer: 'You will be pushed to Audio mixer.',
    stopPushAudioMixer: 'You will be stopped pushing to Audio mixer.',
    hostModifyParticipantName: 'Host has modified your participant name.',
    hostLockParticipantName: 'Host locked participant name that you cannot change.',
    hostChangeAudioLevel: 'The volume effect has switched to the volume bar on the video window.',
    hostChangeAudioBar: 'The volume effect has switched to the audio level on the microphone icon.',
    hostUnlockParticipantName: 'Host unlocked participant name that you can change.',
    supportphoneToBroadcaster: 'Not support phone to be a Broadcaster or Speaker',
    partyNotExist: 'The party does not exist',
    someOneSharing: 'Someone is sharing',
    enterId: 'Invalid Party Code. Please contact the party host',
    deletedParty: 'This party doesn not exist.',
    switchPublicSetting: 'Switch Private Chat',
    switchPublicWords: 'After setting a new session, the current private chat will be hung up. Do you confirm to go on?',
    goOn: 'Go on',
    currentLocalNetWorks: 'Your network connection is unstable and this may affect your experience. We recommend refreshing your browser in order to reset your connection.',
    noResults: 'No Results',
    noRunning: 'No Running Production available',
    noDevices: 'No devices available',
    participantCamera: 'The camera of participant is unavailable.',
    site: 'Site',
    audioPlayPolicy: 'Audio autoplay policy',
    allow: 'Allow',
    audioContents: 'Audio autoplay is not allowed because the limitation of browser. Please click the button "Allow" to get audio stream.',
    abnormalMixing: 'Abnormal mixing',
    refresh: 'Refresh',
    audioMixingAbnormal: 'Your audio mixing is abnormal due to unstable network, please refresh the page.',
    tvuoneVersions: '· Provide all',
    supportedDevices: 'Supported devices',
    tvuoneVersionsOne: 'TVU One with Version',
    tvuoneVersionsTwo: 'V2: 7561+,',
    tvuoneVersionThree: 'V3: 74066+,',
    tvuoneVersionFour: 'MLink V7: 71062+',
    tvuoneVersionFifth: '· 4K Pack is not supported for joining the party',
    for: 'for',
    underAccount: 'under the account',
    live: 'Live',
    edit: 'Edit',
    sectionName: 'Section name',
    noSectionCreated: 'No section has been created',
    canvasTips: 'Create canvas on one Receiver',
    restartVfb: 'Restart VFB',
    restartVfbSuccuss: 'Restart VFB successfully.',
    setSuccess: 'Success'
  },
  arenaMode: {
    noCanvansCreated: 'No canvas created.',
    unLockParty: 'Unlock party',
    lockPartyAndApproach: 'Lock party and approach',
    createCanvans: 'Create canvas',
    rename: 'Rename',
    startNewParty: 'Start a new party',
    title: 'Lock party and approach',
    continue: 'Continue',
    onceUnLockTheParty: 'Once unlock the party:',
    guestNotJoinParty: 'Guest will not be able to join the party.',
    joinedParticipant: 'The joined participants will leave the party.',
    liveTerminated: 'All live feeds will be terminated',
    onceLockTheParty: 'Once lock the party:',
    guestJoinParty: 'Guests can join the openly party.',
    canotModify: 'You will cannot modify canvas.',
    lockPartySuccess: 'Lock party successfully',
    unLockPartySuccess: 'Unlock party successfully',
    deleteTips: 'Do you really want to delete the party?',
    afterEnd: 'After end:',
    deleContentTips: 'All data will be cleared and the party will disappear',
    deleteParty: 'Delete the party',
    createCanvansTitle: 'Create canvas on one Receiver',
    canvansName: 'Canvas name',
    receiver: 'Receiver',
    selectReceiver: 'select receiver',
    inputSeatNumber: 'Please input the seat number for one screen',
    row: 'Row',
    column: 'Column',
    selectLayOut: 'select layout',
    sectionList: 'Section List',
    createSection: 'Create section',
    sectionA: 'Section A',
    canvansCreateTips: 'Operation failed, one canvas can create six max section.',
    nameEmptyTips: 'Name cannot be empty.',
    createCanvansSuccess: 'Create canvas successfully',
    receiverName: 'Receiver name',
    areanaSelectReceiver: 'Select receiver',
    sendToGuest: 'Send to Guest',
    sendGuestSuccess: 'Send to guest successfully',
    preview: 'Preview',
    deletePartySuccess: 'Delete the party successfully'
  },
  addWords: {
    copyLinkTips: `Click the link directly to join ${$cm.title}: \n`,
    turnOnTalkback: 'Turn on "Talkback"',
    turnOffTalkback: 'Turn off "Talkback"',
    commentatorAbnormalNet: 'Network is unstable! Due to network fluctuation you are out of sync with program. Please refresh and/or check your connection.',
    noEvent: 'No Event',
    noEventTips: 'There is no video from event',
    stopShareScreenTip: 'Please stop share screen first.',
    turnOnLazyAudio: 'Turn on Lazy Audio',
    turnOffLazyAudio: 'Turn off Lazy Audio',
    sureDelParty: 'Are you sure you want to delete this party？',
    cancelCohost: 'The host has cancelled your co-host identity.',
    failToJainParty: 'Failed to join party',
    fullParty: 'The number of participants has reached the limitation of ',
    noPermission: 'No Permission',
    participantPassCode: 'Participant passcode',
    enterPassWord: 'Enter participant passcode',
    caseSensitive: 'Passcode is case sensitive',
    accountNotAllowed: 'Your account is not allowed by host. Please contact them for permission.',
    bandWidth: 'Bandwidth Quality',
    stopCrewFailed: 'Stop last Crew failed.',
    commonPartyLimits: 'Common party members out of limit',
    failToTalkBack: 'Turn on failed, Producer does not support this feature.',
    producerNotSupport: 'Producer does not support this feature.',
    productionCrew: 'Now, you are Production Crew and you can start private chat with others.',
    notSelectCurrentSource: 'You cannot replace to current select source, because the current source is the public speaker.',
    vfbSwitchToShare: 'Main Window is playing the source, do you really switch to the shared screen?',
    shareSwitchToVfb: 'Currently using Host Screen, do you really switch to VFB'
  },
  joinPartyWays: {
    clickMenu: 'Click on the menu above',
    openWays: 'Please use Safari or Google Chrome to open it.',
    joinPartyWithBrowser: 'Having issues to download or use TVU Anywhere?',
    accessByBrowser: 'Join by browser',
    or: 'or',
    notInstallText: 'If you do not have the application installed, click the button below to download it.',
    joinPartyLine: 'Open TVU Anywhere app',
    hadInstallAnywhereText: 'If you already have TVU Anywhere app installed, please click the [Open] button in the browser dialog box; or click the button below.',
    toInstallAnyWhere: 'Click on “Download” to go to app store and install TVU Anywhere.',
    downLoadFromStore: 'Download TVU Anywhere app'
  },
  netWorkStatus: {
    Good: 'Good',
    Poor: 'Poor',
    Mid: 'Mid',
    AutoAudioOnly: 'Automatic Audio-Only',
    AutoAudioText: 'If you downlink network is poor, Audio-Only is automatically enable.',
    AllTimeAudioOnly: 'Audio-Only all the time',
    AllTimeAudioText: 'Enable Audio-Only immediately',
    AudioDisabled: 'Audio-Only disabled',
    AudioOnlyDisabledText: 'Turn off Audio-Only all the time.',
    disabelAUdioPopup: 'Audio-Only is disable and always try to load.',
    poorNetworkPopup: 'Poor network, Audio-only is enable and does not load video streams.',
    AllTimeAudioPopup: 'Audio-only is enable and does not load video streams.',
    saveBandWIdth: 'Saving network bandwidth',
    stillWantToLoad: 'Select the videos you still want to load:',
    MainWindow: 'Main window',
    pinnWindow: 'Pinned window',
    SharedScreen: 'Shared Screen',
    Disabled: 'Disabled',
    operationIncludes: 'The option includes:',
    mainwindowByHost: 'Main Window set by host',
    leftRightWindow: 'Left window in Left-Right layout'
  },
  setting: {
    OpenGlobalAnyWhere: 'Open Global Settings for TVU Anywhere',
    OffGlobalAnyWhere: 'Close Global Settings for TVU Anywhere',
    globalAnywhereSetting: 'Global Settings for TVU Anywhere',
    globalAnywhereSettingText: 'The configuration will take effect immediately for all TVU Anywhere participants. And they can still be controlled individually.',
    participantSetting: 'Participant Setting',
    mainWindowSetting: 'Main Window Setting',
    devicesSetting: 'TVU Devices Setting',
    settingName: 'Setting',
    helpCenter: 'Helper',
    mutexPrompt: 'This function is unavailable when "{featureName}" is used.',
    participantTitle: 'Set available functions for all participants of the party',
    titleNote: 'These options only affect VFB (Receiver Video Return) and PP (Producer)',
    note: 'Note:',
    volumeNote1: 'Volume Control - Receiver version 7.7 and lower versions only support audio control for Live Source',
    volumeNote2: 'Volume Control - Receiver version 7.8 or above support Live Source and SDI IN',
    mainwindowTips: 'When there is no one in the party, Main Window will automatically turn off after half an hour.',
    mainWindowTitle: 'It will apply to Main Window and TVU Device of the party',
    shareScreenTitle: 'It will apply to all participants of the party.',
    audioMatrixSetting: 'Audio Matrix Setting',
    participantAudioText: 'You can control your interaction with other participants audio',
    participantSettingText: 'Allow participant to control their own Audio Matrix',
    blueAudioMatrixIcon: 'Unidirectional Audio. You can only hear them.',
    yellowAudioMatrixIcon: 'Unidirectional Audio. They can only hear you.',
    changeParticipants: 'The participants have changed.',
    maximize: 'Maximize',
    minimize: 'Minimize',
    redAudioMatrixIcon: 'Bi-directional inaudible',
    schematic: 'Schematic',
    interpretationChart: 'Interpretation chart',
    audioOut: 'Vertical direction means “Audio OUT”.',
    audioOutText: 'The vertical people “audio out” to the corresponding horizontal person.',
    audioIn: 'Horizontal direction means “Audio IN”.',
    audioInText: 'The horizontal people receive “audio in” from the corresponding vertical person.',
    turnOffs: 'When turned off,',
    turnOffTips: '· All the participants can hear each other',
    turnOns: 'When turned on,',
    turnOnTips: '· You can define whether participants can hear each other',
    noteTips: '· Note: The feature of “set private chat” for Production Crew will be disabled.',
    generalControl: 'General control',
    participantName: 'Participant name',
    intercom: 'Intercom (private chat)',
    volimeEffect: 'Volume Effect',
    turnOff: 'When turned off :',
    turnOn: 'When turned on :',
    lockName: "All participants in the party won't be able to modify their party names.",
    aiSpeech: 'It will show “AI Speech To Text” button at the bottom of all participants pages. Al speech will recognize what all participants are saying.',
    openParticipantPrivat: 'All participants(except TVU Anywhere app) are allowed to start private conversations.',
    partyLink: 'Party link share',
    lockCopy: "All participants in the party won’t be able see 'copy' button and can not share the party link.",
    fullScreen: '"Full screen" button',
    loginAndRegister: '"Login/Register" button',
    muteAll: 'Mute All',
    muteAllTips1: 'Is is one-time operation',
    muteAllTips2: 'Each click mutes the mic of all participants',
    muteAllSuccess: 'Mute all successfuly',
    muteAllParticipantsTips: 'Host has turned your Mic OFF',
    loginButton: 'All participants in the party won’t be able to operate Login/Register',
    loginFunction: 'function.',
    hotJar: 'All participants in the party(including you) won’t be able to see',
    collectTool: 'the collecting feedback tool.',
    liveTool: 'the live chat tool.',
    advanceControl: 'Advanced control',
    highResolution: 'High Resolution',
    turnOnHighResolution: 'When turned on, all participants will use High resolution :',
    selectHighResolution: 'It will automatically select high resolution with network situations.',
    turnOffHighResolution: 'When turned off, all participants will use Low resolution :',
    defaultResolution: 'Low resolution is the default.',
    lazyAudioOn: 'It will show Lazy Audio button in each pip, host and the participant himself can control.',
    terminalReceiver: 'If Lazy Audio is off, the left audio channel will be outputted to Receiver.',
    otherParticipantHear: 'If Lazy Audio is on, the right audio channel will be outputted to Receiver. It won’t be heard by other participants.',
    audioFeedBack: 'Audio Feedback (Allow participant to hear themselves)',
    hearThemselves: 'Web participants in the party(including you) will be able to hear themselves while talking.',
    fullScreenTips: 'All participants "full screen." button on foot will be hidden',
    micAndCamera: 'Mic & Camera icons in pip',
    micAndCameraTips: "Participants page won't have mic/camera icons displayed in the pips.",
    volume: 'Volume from source',
    pipVolume: 'Volume participant',
    volumeHint: 'Changes the volume of the encoded VFB stream.This will be max value participant will be able to hear.',
    volumePipHint: 'Changes the default value of the audio control on all participants and Host Main Window. Participant can modify the volume as needed.',
    adjustedVloume: 'Host has adjusted the volume',
    defaultBitrate: '30(default)',
    notHearSelfTips: 'You can not hear yourself while mic muted',
    offAudioFeedBack: 'Turn off Audio Feedback',
    onAudioFeedBack: 'Turn on Audio Feedback to hear yourself',
    loginShownMessage: 'The Participants login or register button is shown',
    loginHiddenMessage: 'The Participants login or register button is hidden',
    fullScreenShowMessage: 'The Participants fullScreen button on foot is shown',
    fullScreenHiddenMessage: 'The Participants fullScreen button on foot is hidden',
    micAndCameraShowMessage: 'The Participants mic and camera buttons are shown',
    micAndCameraHiddenMessage: 'The Participants mic and camera buttons are hidden',
    hotJarShowMessage: 'The Participants Hotjar is shown',
    hotJarHiddenMessage: 'The Participants Hotjar is hidden',
    chatlioShowMessage: 'The Participants Chatlio is shown',
    chatlioHideMessage: 'The Participants Chatlio is hidden',
    audioBackOperateSuccess: 'Operation successfully',
    bitrateMessage: 'The min bitrate is 200/The max bitrate is 5000',
    minVolumeMessage: 'The max volume is 100',
    mainWindowSaveMessage: 'Save successfully.',
    onCloud: 'Turn on cloud proxy',
    offCloud: 'Turn off cloud proxy',
    proxySetting: 'Proxy Setting',
    cloudProxy: 'Cloud proxy',
    whatCloudProxy: 'What is "Cloud proxy"?',
    restructed: 'Restricted network connection with Cloud Proxy',
    canEnableDescribe: 'You can enable the Cloud Proxy to ensure reliable connectivity for your participants when they connect from an environment with a restricted network.',
    onPipSideDescribe: 'On the participants side, they must have configured their firewall to allow communication through the Cloud Proxy.',
    howEnableCloudProxy: 'How to enable "Cloud proxy"?',
    stepONeDescribe: 'Step 1: The Host need to keep the switch button ON.',
    stepTwoDescribe: "Step 2: The participants and Host in restricted network need to add the following IPs and ports to their enterprise firewall's whitelist.",
    contactEmailContent: 'If you have any questions, please contact us by email:',
    contactFeatureContent: 'If you want to use this feature, please contact us by email:',
    contactEmail: 'support@tvunetworks.com',
    audioMatrix: 'Audio Matrix',
    ShareScreenSetting: 'Share Screen Setting',
    aiSpeechSetting: 'AI Speech Recognition',
    configureWhitelist: 'You can configure based on the port whitelist.',
    receiverRegion: 'Region',
    northAmerica: 'North America',
    europe: 'Europe',
    india: 'India',
    japan: 'Japan',
    southEastAsia: 'South East Asia',
    china: 'China',
    cloudProxyIpRange: 'Cloud Proxy IP range',
    cloudProxyPort: 'Cloud Proxy port',
    accessPointIpRange: 'Access Point IP range',
    accessPort: 'Access Port',
    receiverConfigureAvailable: 'The receivers configured with ports are available.',
    lockNameTips: 'The names of participants have been locked.',
    unlockNameTips: 'The names of participants have been unlocked.',
    OnHighResolution: 'Turn on high resolution',
    OffHighResolution: 'Turn off high resolution',
    nextUse: 'Save for next use',
    intercomNote: 'Note: When this feature is turned off, all private conversations are going to be stopped.',
    meterOnPip: 'VU Meter on pip',
    audioLevel: 'Audio-level on mic icon',
    speechLowQuality: 'Speech Low Quality (Rate 16Khz,Bitrate 24Kbps)',
    speechStandard: 'Speech Standard (Rate 32Khz,Bitrate 24Kbps)',
    musicStandrad: 'Music Standard (Rate 48Khz,Bitrate 32Kbps)',
    highQuality: 'High Quality (Rate 48Khz,Bitrate 128Kbps)',
    standardStereo: 'Standard Stereo (Rate 48Khz,Bitrate 64Kbps)',
    highQualityStereo: 'High Quality Stereo (Rate 48Khz,Bitrate 192Kbps)',
    reStartEffectMsg: 'Devices that are already in the party will not update its format. For the change to take effect, remove and re-add the device in the party',
    deviceLeaveRules: 'Device Leave Rules',
    deviceLeaveContent: 'After no participant in the party, the devices will leave the party after the specified time.',
    immediately: 'Immediately',
    oneHour: '1 hour',
    twoHour: '2 hours',
    twentyFourHour: '24 hours',
    customize: 'Customize'
  },
  partyInfo: {
    cohostLimit: 'A maximum of 10 co-host can be online at the same time.',
    partylineDetail: 'Partyline mode is designed to allow remote (and distributed) video production teams and crews to collaborate and interact.',
    GalleryViewDetail: 'Gallery View mode can place all the fans in a specific grid layout and project as a mosaic for big screens.',
    conferenceDetail: 'Conference mode can be configured to host virtual interviews, press conferences, town halls, or other educational events.',
    kioskDetail: 'Kiosk Mode allows you to create customized experiences with different backgrounds and logos, highlighting the Main Window as the center display.',
    globalControlDetail: 'Global control mode allows a single staff member to manage multiple parties from a central interface.',
    partyline: 'Partyline',
    GalleryView: 'Gallery View',
    conference: 'Conference',
    kiosk: 'Kiosk',
    globalControl: 'Global Control',
    inputLevel: 'Input level',
    startTesting: 'Start testing',
    stopTesting: 'Stop testing',
    note: 'Note: If you can hear yourself, then the microphone is working properly.',
    MicrophoneSelection: 'Microphone selection',
    MicTest: 'Microphone testing',
    testMic: 'Test your Microphone',
    createTime: 'Create time',
    partyID: 'Party ID',
    host: 'Host',
    cohost: 'Co-host',
    joinNow: 'Join now',
    history: 'History records',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    minutes: 'minutes',
    searchPlaceHolder: 'party name/party ID',
    maxLimit: 'Maximum limit',
    noPartyCode: 'There is not have partyCode to join party',
    joinFailed: 'Please, input your nickname and party name before proceeding',
    nameCannotEmpty: 'Please input your nickname before proceeding.',
    tvu: 'TVU',
    notNeedVideo: 'The camera is not used in {partyModule} mode.',
    partylineTitle: 'Partyline',
    manage: 'Manage',
    maxPips: 'Max pips',
    editSubParty: 'Edit sub-party',
    switchOutput: 'Switch output',
    notConnect: 'Not connected. Connecting...',
    partyState: 'Party state',
    disableParty: 'Disable party',
    enableParty: 'Enable party',
    enable: 'Enable',
    disable: 'Disable',
    disableMean: '"Disable party" means that party would still exist, but everybody will leave and cannot rejoin.',
    disableConfrimText: 'Do you want to disable party?',
    enableMena: '“Enable party” means that party open, and everybody can rejoin.',
    enableConfrimText: 'Do you want to enable party?',
    unableJoin: 'Unable to join',
    deletedParty: 'Party ID does not exist.',
    partyDisable: 'The party as it may have been deleted or does not exist.',
    partyDisabled: 'This party has been disabled',
    inputNumber: 'Please input right number',
    rightValue: 'Please enter a right bitrate number between 200 and 5000.',
    modifyMaxPip: 'Party is enabled, cannot modify Max pips.',
    cancelInvited: 'Host has cancel invited you.',
    rejoin: 'Rejoin'
  },
  aiSpeech: {
    diabledTitle: 'The feature is unavailable',
    openAiSpeech: 'Open AI Speech',
    start: 'Start recognizing speech',
    stop: 'Stop recognizing speech',
    title: 'AI Speech To Text',
    translateInto: 'Translate into',
    download: 'Download',
    mainwindow: 'Main Window',
    webParticipants: 'Web-participants',
    tvuAnywhereParticipants: 'TVU Anywhere-participants',
    receiverParticipants: 'Receiver-participants',
    tvuOneParticipants: 'TVUOne-participants',
    tvuAppParticipants: 'TVU Partyline app-participants',
    mediaParticipants: 'Media Hub-participants',
    helpTips: 'Select the source type for which you want to display recognized text.',
    me: 'me',
    notSupportCopy: 'The browser does not support copying text to the clipboard.',
    copySuccess: 'Copy successfully',
    copyFail: 'Copy failed',
    aiAssistant: 'AI Assistant',
    aiSummary: 'AI Summary',
    getSummaryFailed: 'Failed to get summary',
    executeSuccess: 'Execute successfully',
    executeFailed: 'Execute failed',
    selectPP: 'Producer Production',
    translate: 'Translate',
    noContentSummary: 'No content to summarize at this time.',
    aiPolicyTitle: 'AI Speech To Text',
    aiPolicyGeneratedText: 'AI Speech To Text uses Al technology, which may include third-party models. Host‘s and participants’ speech can be recognized and displayed as text, and party summaries can be generated.',
    aiPolicyModelText: "TVU Partyline does not use any audio, video, chat, screen sharing or other communications-like content to train TVU Partyline's or third-party Al models.",
    aiPolicyAccuracyText: 'Al-generated content may be inaccurate or misleading. Always check for accuracy.',
    sendByEmail: 'Send by Email',
    sendBySlack: 'Send by Slack',
    errorEmail: 'Incorrct email format',
    sendEmailTips: 'The AI Summary will be sent to the address set up as follows.',
    sendEmailTips2: 'After ending the party, the AI summary will be automatically sent to the list.',
    sendSlackTips: 'You can get the Slack email address from Slack Channel Details or Slack User Details and add it here.',
    noTranscript: 'No transcription has been summarized yet.',
    emailSaving: 'Email saving...',
    emailSaved: 'Email saved.',
    deleteEmailSuccess: 'Delete email successfully.',
    notInputLan: 'Please select a language first.',
    English: 'English',
    Chinese: 'Chinese',
    Korean: 'Korean',
    Japanese: 'Japanese',
    Spanish: 'Spanish',
    Portugues: 'Portugues',
    French: 'French'
  },
  micMutedInfo: {
    title: 'Microphone unavailable',
    ignore: 'Ignore',
    contentTitle: 'Your mic is muted by your system setting.',
    contentMessage: "Go to your computer's settings to unmute your mic and adjust its level.",
    openBtnMes: 'Open Sound Settings'
  },
  voiceCommand: {
    title: 'AI Voice Command',
    tips: 'Actions can be performed by voice command.',
    step1: 'Step 1:',
    step1Text: 'Assign participants to operate the voice commands.',
    magicWord: 'Hey Bot',
    step2: 'Step 2:',
    step2Text: 'Confirm in advance which Producer program you are going to voice control.',
    step3: 'Step 3:',
    step3Text: 'Wake up the AI robot with word command',
    step4: 'Step 4:',
    step4Text: 'Use the following recommended voice commands to have the robot perform the appropriate actions.',
    SelectProducerProgram: 'Select Producer Program:',
    defaultText: 'Try saying “Set slot x(number) as PGM”',
    voiceSend: 'Voice command is being send, please wait...',
    sendSuccess: 'Command Executed Succcessfully!',
    sendFailed: "I don't get it. Say it again, please.",
    programNotExists: 'Please select a working Producer program first.',
    voiceWord: 'Recommended voice word',
    action: 'Action',
    switchPgm: 'Switch video/source/slot to PGM',
    switchPvw: 'Switch video/source/slot to PVW',
    cutPvwToPGm: 'Cut PVW to PGM',
    curOverlayToPgm: 'Cut Overlay to PGM',
    setSlotAsPvm: 'Set slot x(number) as PVW',
    setSlotAsPgm: 'Set slot x(number) as PGM',
    selectParticipant: 'Select participants:',
    summaryGenerate: 'AI summary is being generated, please wait...',
    summaryTime: 'Summary data from ',
    participantNoProductId: 'There is no product ID, please contact the host to select it.'
  },
  anywhereSetting: {
    tvuAnywhere: 'TVU Anywhere App',
    partylineApp: 'Partyline App',
    pid: 'PID',
    missProperties: 'This TVUA does not support Remote Control',
    setting: 'Remote Setup',
    framesRate: 'Frames rate',
    switchCamera: 'Switch Camera',
    switchMic: 'Switch Mic',
    defaultView: 'Default view',
    balance: 'White Balance Settings',
    scenes: 'Scenes',
    temperature: 'Color Temperature',
    tints: 'Color Tints',
    lockApp: 'Lock {deceiveType} app',
    lockApps: 'Lock TVU Anywhere app',
    autoFocus: 'Auto Focus',
    autoExposure: 'Auto Exposure',
    focusValue: 'Focus Value',
    exposureValue: 'Exposure Value',
    scenesTips: 'Select white balance parameters for different scenes',
    lockAppTips: "Once it's locked, {deceiveType} users can’t do any operations on their page.",
    lockAppTitle: "Once it's locked, TVU Anywhere users can’t do any operations on their page.",
    zoomText: 'Zoom',
    speakerText: 'Speaker Volume',
    positionTips: 'After connecting the gimbal, two fixed positions can be preset for quick application.',
    positionText: 'Pre-position',
    positionOne: 'Position_1',
    positionTwo: 'Position_2',
    positionSetting: 'Position Setting',
    positionBtnDisabledTips: 'Please set the position information in "Settings" before use.',
    positionBtnActiveTips: 'Click to apply the position to App.',
    manualSet: 'Manual Set',
    preposition: 'Pre-position Setting',
    prepositionName: 'Pre-position',
    upDown: 'Up / Down:',
    leftRight: 'Left / Right:',
    del: 'Cancel',
    save: 'Save',
    reset: 'Reset',
    autoWhiteBalance: 'Auto WhiteBalance',
    userLeft: 'This TVU Anywhere participant has left the party.',
    'Selfie (Front-facing Camera)': 'Selfie (Front-facing Camera)',
    'Main (Rear Camera)': 'Main (Rear Camera)',
    'Main+Selfie (distant view)': 'Main + Selfie (distant view)',
    'Main+Selfie (near view)': 'Main + Selfie (near view)',
    fullScreen: 'Full Screen',
    partylineView: 'Partyline View',
    prePosition: 'The operation failed, please reset the pre-position value.'
  },
  pushTalk: {
    pushTalk: 'Push To Talk',
    breakoutRoom: 'Breakout Room',
    people: 'people',
    noMembers: 'No member',
    room: 'Group',
    pushTalkTips: 'You can create and manage private chat groups',
    enableParticipants: 'Allow participant to manage their "Push To Talk"',
    muteAudio: 'When Push to Talk enabled,mute audio on output',
    manageTips: 'Manage "Push To Talk" group',
    rename: 'Rename',
    assign: 'Assign',
    delete: 'Delete',
    shortCut: 'On Home page, Click and Hold the shortcut [{index}] to enable this “Group Talk” button.',
    notAllowed: 'Operation failed, please stop Audio matrix or Intercom first.',
    groupTips1: '1. The group creator will have the corresponding “Group Talk” buttons.',
    groupTips2: '2. Click and Hold the button to only talk to the participants that are in this group.',
    deleteGroupText: 'Do you confirm to delete the breakout room?',
    deleteGroup: 'Delete breakout room',
    deleteParticipant: 'Delete participant',
    deleteParticipantText: 'Do you confirm to remove the participant from the breakout room?',
    move: 'Move',
    moveTitle: 'Move the participant into:',
    puskTalkFootTips: 'Click and Hold {index} to talk to “{groupName}”',
    groupName: 'Group name:',
    inputName: 'Please input group name',
    createGroup: 'Create group',
    create: 'Create',
    participantHolder: 'Search for participant name',
    notSupport: 'The feature is not currently supported for TVU Anywhere participants.',
    enterGroupName: 'Please enter the group name'
  },
  detail: {
    deviceName: 'Device name',
    deviceType: 'Device type',
    devicePid: 'PID',
    deviceVersion: 'Device version',
    programName: 'Program name',
    tvuOne: 'TVUOne',
    tvuReceiver: 'TVU Receiver',
    tvuProducer: 'TVU Producer',
    tvuChaneel: 'TVU Channel',
    tvuCloudR: 'TVU Cloud R'
  },
  intercom: {
    intercom: 'Intercom',
    talent: 'Talent',
    station: 'Stations',
    stations: 'Stations',
    sessionName: 'Session name',
    click: 'Click',
    copy: 'Copy',
    buttonInvite: 'button to invite',
    partylineApp: 'App',
    users: 'users',
    addPack: 'button to add Pack devices.',
    addReceiver: 'button to add Receiver devices.',
    talkToAll: 'Talk to All',
    userId: 'User ID:',
    bottomTips1: 'Select a “Talent” and a “Station”, and click "Connect" button to establish a talk between them.',
    bottomTips2: 'At the same time, you can also hear them.',
    talentTips: 'List of devices on Production Field.',
    stationTips: 'List of sources on local station producers.',
    copied: 'Copied',
    copyUserId: 'Copy user ID',
    voip: 'VoIP',
    app: 'App',
    packSdi: 'Pack with SDI/HDMI',
    receiveSdi: 'Receiver with SDI/HDMI',
    connectTo: 'Connect to {deviceName}',
    creator: 'Creator:',
    searchPepole: 'Search Talent',
    searchStation: 'Search stations',
    session: 'Session',
    createSession: 'Create a session',
    status: 'Status',
    speaker: 'Speaker',
    operation: 'Remove',
    notSelectStation: 'Please select a station first before create a group.',
    active: 'Active',
    inactive: 'Inactive',
    createGroupSuccess: 'Create a group success',
    deleteSessionTitle: 'Delete session',
    deleteSessionText: 'Are you sure to delete this session?',
    talkToAllTalents: 'Talk to All Talent',
    cannotSwitchStation: 'Please click the active button to stop first, if you want to switch station.',
    changeSessionName: 'Change session name',
    sessionNameEmpty: 'Session name cannot be empty.',
    onlyOneActive: 'There can be only one session active.',
    noSession: 'Please select a session first.',
    removeParticipant: 'Remove from room',
    cannotDeleteSession: 'The current session is in active, you cannot delete it.',
    talkToTalent: 'Talk to Talent',
    talkToSession: 'Talk to Session',
    talk: 'Talk',
    talking: 'talking',
    enableActiveFailed: 'Enable failed, you need to select at least one talent and one station.',
    longpressTips: 'Long press to take effect',
    addToIntercom: 'Add to Intercom',
    activeSession: 'Host actived the session',
    deactiveSession: 'Host deactived the session',
    webStationHasTalk: 'Web station {staionName}({sessionName}) has talk to you.',
    webStationEndTalk: 'Web station {staionName}({sessionName}) has end talk to you.',
    webUi: 'Web UI:',
    deviceVoIP: 'Device VoIP:',
    pushTalkToStation: 'Host has push talk to you.',
    pushTalkToStationEnd: 'Host has end push talk to you.',
    pushToHost: 'Push To Host',
    quicklyOperation: 'The operation time is too short, please try again.',
    on: 'On',
    off: 'OFF',
    cannotTalkToTalent: 'If you want to talk to talent please stop talk to session first.',
    cannotTalkToTalentByTalkALL: 'If you want to talk to talent please stop talk to all talent first.',
    cannotTalkToSession: 'If you want to talk to session please stop talk to talent first.',
    cannotTalkToSessionByTalkAll: 'If you want to talk to session please stop talk to all talent first.',
    cannotTalkAllTalent: 'If you want to talk to all talent please stop talk to talent or talk to session first.'
  }
}
